import { render, staticRenderFns } from "./qualification-plan-submit-dialog.vue?vue&type=template&id=12a0f1c2&scoped=true"
import script from "./qualification-plan-submit-dialog.vue?vue&type=script&lang=js"
export * from "./qualification-plan-submit-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a0f1c2",
  null
  
)

export default component.exports